import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { buildReferralLink, buildPartnerJoinLink, canShowPartnerJoinLink } from "../constants/partnerEnums";

const PartnerReferralLinkDialog = ({ open, onClose, partner }) => {
  if (!partner) return null;

  const referralLink = buildReferralLink(partner.referralCode);
  const partnerJoinLink = canShowPartnerJoinLink(partner)
    ? buildPartnerJoinLink(partner.referralCode)
    : "";

  const copyLink = async (text, message) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      toast.success(message);
    } catch {
      toast.error("کپی لینک ناموفق بود.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>لینک‌های معرف — {partner.referralCode || "—"}</DialogTitle>
      <DialogContent dividers>
        {!partner.referralCode ? (
          <Alert severity="info">کد معرف برای این نماینده ثبت نشده است.</Alert>
        ) : (
          <>
            <Box sx={{ mb: partnerJoinLink ? 2 : 0 }}>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                لینک معرف مشتری
              </Typography>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <TextField value={referralLink} fullWidth InputProps={{ readOnly: true }} />
                <IconButton
                  color="primary"
                  onClick={() => copyLink(referralLink, "لینک معرف کپی شد.")}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Box>
            </Box>
            {partnerJoinLink ? (
              <Box>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                  لینک ثبت‌نام زیرمجموعه
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <TextField value={partnerJoinLink} fullWidth InputProps={{ readOnly: true }} />
                  <IconButton
                    color="primary"
                    onClick={() =>
                      copyLink(partnerJoinLink, "لینک ثبت‌نام زیرمجموعه کپی شد.")
                    }
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </Box>
              </Box>
            ) : null}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerReferralLinkDialog;
